module.exports = __webpack_public_path__ + "img/ascend_gold19.74ca4f78.png";